import { useTranslation } from 'react-i18next'
import { HeroBackdrop } from '#app/components/hero-backdrop.tsx'
import { type Route } from './+types/privacy.ts'

export const meta: Route.MetaFunction = () => [
	{
		title: 'Datenschutz | Open Sourced',
	},
	{
		name: 'description',
		content:
			'Datenschutzerklärung der Open Sourced GmbH, Lostorf, Switzerland.',
	},
]

export default function PrivacyRoute() {
	const { t } = useTranslation()

	const sections = t('legal.privacy.sections', {
		returnObjects: true,
	}) as Array<{ title: string; content: string }>

	return (
		<>
			{/* Hero */}
			<section className="relative overflow-hidden pt-32 pb-24">
				<HeroBackdrop />

				<div className="container relative z-10 text-center">
					<h1 className="mx-auto max-w-3xl text-h3 sm:text-h2 md:text-h1 hyphens-manual break-words">
						{t('legal.privacy.heading')}
					</h1>
				</div>
			</section>

			{/* Sections */}
			<section className="py-24">
				<div className="container max-w-3xl">
					<div className="space-y-10">
						{Array.isArray(sections) &&
							sections.map((section, index) => (
								<article key={index}>
									<h2 className="text-h4 mb-3 break-words">
										{section.title}
									</h2>
									<p className="text-body-md text-muted-foreground">
										{section.content}
									</p>
								</article>
							))}
					</div>
				</div>
			</section>
		</>
	)
}
